import createEmojiNode from './createEmojiNode';
import addEmojiToMru from '../actions/addEmojiToMru';
import resetNumSearchesToInsertEmoji from '../actions/resetNumSearchesToInsertEmoji';
import ExpressionPage from '../store/schema/ExpressionPage';
import { logUsage } from 'owa-analytics';
import expressionStore from 'owa-expressions-store/lib/store/expressionStore';
import ExpressionPickerOpenedSource, {
    INLINE_SEARCH_OPENED_SOURCE,
    SMART_SUGGESTIONS_OPENED_SOURCE,
    CONTEXTUAL_SEARCH_OPENED_SOURCE,
} from 'owa-expressions-store/lib/store/schema/ExpressionPickerOpenedSource';

export default function addEmoji(
    emojiKey: string,
    insertEmoji: (node: HTMLElement) => void,
    source: ExpressionPickerOpenedSource,
    expressionId: string
): HTMLElement {
    const emojiNode = createEmojiNode(emojiKey);
    if (emojiNode) {
        insertEmoji(emojiNode);

        // Log EmojiInserted datapoint
        const expressionPickerViewState = expressionStore.expressionPickerViewStates.get(
            expressionId
        );
        const isInlineSearch: boolean = source === INLINE_SEARCH_OPENED_SOURCE;
        logUsage('ExpressionPicker_EmojiInserted', [
            emojiNode.id /* codepoint */,
            !isInlineSearch && expressionPickerViewState.searchTerm !== '' /* isSearch */,
            false /* isContextual */,
            source === CONTEXTUAL_SEARCH_OPENED_SOURCE /* isFromContextualPopup */,
            source === SMART_SUGGESTIONS_OPENED_SOURCE /* isSmartSuggestion */,
            !isInlineSearch && expressionPickerViewState.page === ExpressionPage.All /* isAll */,
            expressionPickerViewState
                ? expressionPickerViewState.numSearchesToInsertEmoji
                : 0 /* numSearchesToInsertEmoji */,
            isInlineSearch /* isInline */,
        ]);

        // Add emoji to MRU
        addEmojiToMru(emojiKey);

        // Reset tracker for number of searches to insert emoji
        if (expressionPickerViewState) {
            resetNumSearchesToInsertEmoji(expressionPickerViewState);
        }

        return emojiNode;
    }

    return null;
}
